exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---2h1gN {\n  display: block;\n  margin: 2px; }\n\n.svgIconContainer---3dw8Y {\n  width: 17px;\n  height: 17px;\n  margin: 3px; }\n\n.svgIconContainer---3dw8Y svg path {\n    fill: white !important; }\n\n.button---1-qFu, .assign---3jr_B {\n  height: 25px;\n  min-width: 135px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  border: 1px solid #959595;\n  margin-left: 5px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.assignedStudents---3ReKh {\n  padding: 2px; }\n\n.assign---3jr_B {\n  min-width: 110px;\n  display: inline-block;\n  padding: 0 15px; }\n\n.assign---3jr_B > div {\n    height: 100%; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2h1gN",
	"svgIconContainer": "svgIconContainer---3dw8Y",
	"button": "button---1-qFu",
	"assign": "assign---3jr_B",
	"assignedStudents": "assignedStudents---3ReKh"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/formatters/student-count-formatter/index.scss
// module id = 1163
// module chunks = 3